import { AppLanguage, normalizeAppLanguage } from "@xlabmedical/medic-web-framework";
import defaultEN from "@xlabmedical/medic-web-framework/locales/webcad_translations_en.json";
import type { Composer } from "vue-i18n";
import { getI18n } from "@/plugins/vueI18n";

// @ts-expect-error: typecheck warning for store type
export const webRgLocaleProps = (localizationSettings) => {
    const messages = defaultEN;
    const locale = normalizeAppLanguage(localizationSettings.getAppLanguage());

    return {
        legacy: false,
        locale,
        fallbackLocale: AppLanguage.EN,
        messages: { [AppLanguage.EN]: messages },
    };
};

const composer = () => getI18n().global as unknown as Composer;

// Overloads to match vue-i18n
export function translation(key: string): string;
export function translation(key: string, list: unknown[]): string;
export function translation(key: string, named: Record<string, unknown>): string;

export function translation(key: string, namedOrList?: Record<string, unknown> | unknown[]): string {
    const c = composer();
    return namedOrList !== undefined ? c.t(key, namedOrList as any) : c.t(key);
}
